import { render } from "./AdminSideBarItem.vue?vue&type=template&id=3961e8d7&scoped=true"
import script from "./AdminSideBarItem.vue?vue&type=script&lang=js"
export * from "./AdminSideBarItem.vue?vue&type=script&lang=js"

import "./AdminSideBarItem.vue?vue&type=style&index=0&id=3961e8d7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3961e8d7"]])

export default __exports__